import React from "react";
import { SectionContainer, MainTitle, Image, ButtonContent } from "./styles";
import image from "../../assets/integracao.png";
import { RiExternalLinkLine } from "react-icons/ri";
import { Button } from "../../styles";
import mob1 from "../../assets/1-mob.svg";
import mob2 from "../../assets/2-mob.svg";
import mob3 from "../../assets/3-mob.svg";

const Integration = () => {
  return (
    <SectionContainer>
      <MainTitle>Integração rápida para desenvolvedores</MainTitle>
      <ButtonContent>
        <Button>
          <RiExternalLinkLine color="#ffffff" />
          Documentação
        </Button>
      </ButtonContent>
      <Image web alt="imagem" src={image} />
      <Image alt="imagem" src={mob1} />
      <Image alt="imagem" src={mob2} />
      <Image alt="imagem" src={mob3} />
    </SectionContainer>
  );
};

export default Integration;
